import { getUserGroupsFromToken } from './jwt.js';
/**
 * User roles in the system (mapped from Cognito groups)
 */
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admins";
    UserRole["COACH"] = "coaches";
    UserRole["USER"] = "users";
})(UserRole || (UserRole = {}));
/**
 * Check if user has a specific role
 *
 * @param authorizationHeader - Authorization header value
 * @param requiredRole - Required role
 * @returns True if user has the role
 */
export const hasRole = (authorizationHeader, requiredRole) => {
    const groups = getUserGroupsFromToken(authorizationHeader);
    return groups.includes(requiredRole);
};
/**
 * Check if user has any of the specified roles
 *
 * @param authorizationHeader - Authorization header value
 * @param roles - Array of acceptable roles
 * @returns True if user has at least one of the roles
 */
export const hasAnyRole = (authorizationHeader, roles) => {
    const groups = getUserGroupsFromToken(authorizationHeader);
    return roles.some((role) => groups.includes(role));
};
/**
 * Check if user has the 'users' role
 *
 * @param authorizationHeader - Authorization header value
 * @returns True if user is in the 'users' group
 */
export const isUser = (authorizationHeader) => {
    return hasRole(authorizationHeader, UserRole.USER);
};
/**
 * Check if user has the 'coaches' role
 *
 * @param authorizationHeader - Authorization header value
 * @returns True if user is in the 'coaches' group
 */
export const isCoach = (authorizationHeader) => {
    return hasRole(authorizationHeader, UserRole.COACH);
};
/**
 * Check if user has the 'admins' role
 *
 * @param authorizationHeader - Authorization header value
 * @returns True if user is in the 'admins' group
 */
export const isAdmin = (authorizationHeader) => {
    return hasRole(authorizationHeader, UserRole.ADMIN);
};
/**
 * Require specific role or throw error
 *
 * @param authorizationHeader - Authorization header value
 * @param requiredRole - Required role
 * @throws Error if user doesn't have the required role
 */
export const requireRole = (authorizationHeader, requiredRole) => {
    if (!hasRole(authorizationHeader, requiredRole)) {
        throw new Error(`Forbidden: Required role '${requiredRole}' not found in user token`);
    }
};
/**
 * Require any of the specified roles or throw error
 *
 * @param authorizationHeader - Authorization header value
 * @param roles - Array of acceptable roles
 * @throws Error if user doesn't have any of the required roles
 */
export const requireAnyRole = (authorizationHeader, roles) => {
    if (!hasAnyRole(authorizationHeader, roles)) {
        throw new Error(`Forbidden: Required one of roles [${roles.join(', ')}] not found in user token`);
    }
};
//# sourceMappingURL=rbac.js.map